import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-dark",
  id: "footer",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "container text-md-left" }
const _hoisted_3 = { class: "row d-flex align-items-center flex-wrap border-bottom pb-3" }
const _hoisted_4 = {
  class: "col-md-3 mt-5",
  id: "contact"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase font-weight-bold text-white mb-3" }, " Contact ", -1)
const _hoisted_6 = { class: "nav flex-column text-white opacity-75" }
const _hoisted_7 = {
  class: "col-md-3 mt-5",
  id: "menu"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase font-weight-bold text-white" }, "Menu", -1)
const _hoisted_9 = { class: "nav flex-column" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_15 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-5 mt-5",
  id: "textSection"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white opacity-75" }, " Et has minim elitr intellegat. Mea aeterno eleifend antiopam ad, nam no suscipit quaerendum. At nam minimum ponderum. Est audiam animal molestiae te. Ex duo eripuit mentitum. ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-center text-white py-4",
  id: "copyrights"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "© PlentyFull. All rights reserved.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item,
                class: "nav-item"
              }, [
                _createElementVNode("p", null, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("ul", _hoisted_9, [
            (_ctx.role.length === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass(["nav-link", {
                    'link-white opacity-75': _ctx.$route.path !== '/',
                    active: _ctx.$route.path === '/',
                  }]),
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Home")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass(["nav-link", {
                    'link-white opacity-75': _ctx.$route.path !== '/about',
                    active: _ctx.$route.path === '/about',
                  }]),
                      to: "/about"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("About")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("li", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass(["nav-link", {
                    'link-white opacity-75': _ctx.$route.path !== '/register',
                    active: _ctx.$route.path === '/register',
                  }]),
                      to: "/register"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Register")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass(["nav-link", {
                    'link-white opacity-75': _ctx.$route.path !== '/login',
                    active: _ctx.$route.path === '/login',
                  }]),
                      to: "/login"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Login")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.role === 'Donor' || _ctx.role === 'Charity')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.role === 'Donor')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                              _createVNode(_component_router_link, {
                                class: _normalizeClass(["nav-link", {
                        'link-white opacity-75': _ctx.$route.path !== '/donate',
                        active: _ctx.$route.path === '/donate',
                      }]),
                                to: "/donate"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Donate")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]))
                          : (_openBlock(), _createElementBlock("li", _hoisted_15, [
                              _createVNode(_component_router_link, {
                                class: _normalizeClass(["nav-link", {
                        'link-white opacity-75': _ctx.$route.path !== '/receive',
                        active: _ctx.$route.path === '/receive',
                      }]),
                                to: "/receive"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Receive")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ])),
                        _createElementVNode("li", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(["nav-link", {
                      'link-white opacity-75': _ctx.$route.path !== '/find',
                      active: _ctx.$route.path === '/find',
                    }]),
                            to: "/find"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Find")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        (_ctx.role === 'Donor')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                              _createVNode(_component_router_link, {
                                class: _normalizeClass(["nav-link", {
                      'link-white opacity-75': _ctx.$route.path !== '/transactions',
                      active: _ctx.$route.path === '/transactions',
                    }]),
                                to: "/transactions"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Transactions")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(["nav-link", {
                      'link-white opacity-75': _ctx.$route.path !== '/statistics',
                      active: _ctx.$route.path === '/statistics',
                    }]),
                            to: "/statistics"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Statistics")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("li", _hoisted_19, [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(["nav-link", {
                      'link-white opacity-75': _ctx.$route.path !== '/statistics',
                      active: _ctx.$route.path === '/statistics',
                    }]),
                            to: "/statistics"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Statistics")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _createElementVNode("li", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(["nav-link", {
                      'link-white opacity-75': _ctx.$route.path !== '/registry',
                      active: _ctx.$route.path === '/registry',
                    }]),
                            to: "/registry"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Registry")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ], 64))
                ], 64))
          ])
        ]),
        _hoisted_21
      ]),
      _hoisted_22
    ])
  ]))
}